<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        휴/복직신청
      </v-col>
    </v-row>
    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field
        label="복직예정일"
        v-model="reInDate"
        readonly
      ></v-text-field>
      <keep-alive>
        <v-text-field label="복직사유" v-model="refReason"></v-text-field>
      </keep-alive>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
      <br>
      <div>※복직 신청 시, <font color="red">이익부서 인원은 결재선 변경</font>을 통해<br> <font color="red">휴직 전 부서 실/본부장 결재로 변경</font>하여 신청 바랍니다.</div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>

    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg/
import routerNames from '@/const/routerConstants';
import { getLeaAbsAppDetApplLvlCode } from '@/api/workStatus';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';

export default {
  data: () => ({
    reInDate: '',
    period: '',
    famNm: '',
    birthDay: '',
    refReason: '',
    fileFlag: false,
    fileShow: true,
  }),

  components: {
    IconApprovalDoc,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
  },

  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
    ]),
    ...mapGetters([
      'GET_APPL_CD',
      'GET_CODE',
      'GET_CODE1',
      'GET_BIRTHDAY',
      'GET_CODE_NM',
      'GET_USER_DATA',
      'GET_LIMIT_TERM',
      'GET_FAM_SEQ',
      'GET_FILE_SEQ',
      'GET_PARAMS',
    ]),
  },

  methods: {
    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },

    async applovalPage() {
      if (this.refReason.trim() === '') {
        alert('복직사유를 입력해 주세요');
        return;
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '') {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        applTypeCd: '10', //본인신청
        //refSdate: this.GET_S_YMD, //복직신청인 경우 공란
        //refEdate: this.GET_E_YMD,
        returnYmd: this.reInDate,
       // famCd: this.GET_CODE1,
       // famNm: this.GET_CODE_NM,
       // famSeq: this.GET_FAM_SEQ,
        refReason: this.refReason,
        remainDaysBefore: this.GET_LIMIT_TERM,
        //usedDaysBefore: this.GET_LIMIT_TERM - this.period, 현재는 사용하지 않음
        caDays: this.period,
        applCd: this.GET_APPL_CD,
      };

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_LEAABS_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },
  },

  async mounted() {
    this.reInDate = this.GET_S_YMD;

    this.refReason =
      this.GET_PARAMS.refReason === undefined ? '' : this.GET_PARAMS.refReason;

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }

    let params = {
      searchApplYmd: dayjs().format('YYYYMMDD'),
    }

    let response = await getLeaAbsAppDetApplLvlCode(params);

    if (response.data.data !== null) {
      if(response.data.data.levCode !== undefined) {
        this.$store.commit('ELA/SET_ORG_LVL', response.data.data.levCode);
      }
    }
  },
};
</script>

<style></style>
